import React, { useState } from 'react';
import {
  Container,
  Box,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  useColorModeValue,
  useDisclosure,
  Grid,
  GridItem,
  Flex,
  useBreakpoint,
  Skeleton,
} from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import { CreateMasterWalletModal } from '../../components/CreateMasterWalletModal/CreateMasterWalletModal';
import { Header } from '../../components/Header';
import { WalletSection } from '../../components/WalletSection/WalletSection';
import { TrendingIcon, CopyIcon, RobotIcon } from '../../components/icons';
import { POPULAR_ADDRESSES, RECENT_COPIES, AI_PICKS } from '../../constants/addresses';
import { useWallet } from '../../contexts/WalletContext';
import { Typography } from '@/kit/antipad-ui/Typography';
import { Chip } from '@/kit/antipad-ui/Chip';
import { Button as ButtonKit } from '@/kit/antipad-ui/Button';
import { Flex as FlexKit } from '@/kit/antipad-ui/Flex';
import { Tag } from '@/components/Tag';
import Input from '@/kit/antipad-ui/Input';
import styles from './styles.module.css';
import { WalletPreview } from '@/components/WalletPreview';
import { GridTitleItem, WalletsMobile, WalletsPreloader } from './components';
import { spacing } from '@/kit/antipad-ui';
import { useGetKol, useGetSmartMoney } from './hooks';

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

type State = {
  wallet: string;
}
export const Home: React.FC = () => {
  const [{ wallet }, set] = useState<State>({
    wallet: '',
  });

  const { data: smartMoney, isPending: isSmartMoneyPending } = useGetSmartMoney();
  const { data: kol, isPending: isKolPending } = useGetKol();

  const dispatch = (payload: Partial<State>) => set((prev) => ({ ...prev, ...payload }));

  const navigate = useNavigate();
  const { publicKey } = useWallet();
  const {
    isOpen: isMasterModalOpen,
    onOpen: onMasterModalOpen,
    onClose: onMasterModalClose,
  } = useDisclosure();

  const screen = useBreakpoint();
  const isMobile = screen === 'base';

  const bgGradient = useColorModeValue(
    'linear-gradient(135deg, #0967D2 0%, #805AD5 25%, #3182CE 50%, #6B46C1 75%, #0967D2 100%)',
    'linear-gradient(135deg, #1A365D 0%, #322659 25%, #2C5282 50%, #44337A 75%, #1A365D 100%)'
  );

  const handleCreateMaster = (address: string) => {
    navigate(`/portfolio?address=${address}`);
  };

  const handleViewMyPortfolio = () => {
    if (publicKey) {
      navigate(`/portfolio?address=${publicKey.toString()}`);
    }
  };

  return <div className={styles.page}>
    <div className={styles.heading}>
      <Header />
    </div>

    <main className={styles.main}>
      <div className={styles.container}>
        <FlexKit direction="column" align='center' fullWidth>
          <div className={spacing({ mb: isMobile ? '4x' : '8x' })}>
            <Tag>
              <Typography variant='regular_s' color="#7A60FF">
                Alpha version
              </Typography>
            </Tag>
          </div>
          <div className={spacing({ mb: isMobile ? '4x' : '8x' })}>
            <Typography align='center' style={{ fontWeight: 600 }} variant={isMobile ? '3xLarge_heading' : 'hero_medium'}>
              Solana Wallet Cloner
            </Typography>
          </div>
          <div style={{ marginBottom: isMobile ? '25px' : '50px' }}>
            <Typography align='center' variant={isMobile ? 'small' : 'medium'} color="var(--color-content-tertiary)">
              Copy the most successful Solana traders and make money.
            </Typography>
          </div>

          <div style={{ maxWidth: '572px', width: '100%', marginBottom: isMobile ? '25px' : '80px' }}>
            <Input value={wallet} onKeyUp={(e) => {
              if (e.key === 'Enter') {
                handleCreateMaster(wallet);
              }
            }} onChange={(e) => dispatch({ wallet: e.target.value })} RenderAfter={<ButtonKit disabled={!wallet} size={isMobile ? 'm' : 'l'} onClick={() => handleCreateMaster(wallet)}>Check</ButtonKit>} fullWidth />
          </div>

          {isMobile ?
            <div style={{ width: '100%', marginBottom: '80px' }}>
              <WalletsMobile />
            </div> :
            <div className={styles.well}>
              <FlexKit direction="column" gap="2xl">
                <GridTitleItem title='Smart Money' icon='star' />
                {isSmartMoneyPending ?
                  <WalletsPreloader /> :
                  <>
                    {(smartMoney || []).map((address) => (
                      <WalletPreview adress={address.wallet_address} />
                    ))}
                  </>
                }
              </FlexKit>

              <FlexKit direction="column" gap="2xl">
                <GridTitleItem title='TOP KOLs' icon='fire' />
                {isKolPending ?
                  <WalletsPreloader /> :
                  <>
                    {(kol || []).map((address) => (
                      <WalletPreview adress={address.wallet_address} />
                    ))}
                  </>
                }

              </FlexKit>

              {/* <FlexKit direction="column" gap="2xl">
                <GridTitleItem title='Most Profitable' icon='flash' />
                {AI_PICKS.map((address) => (
                  <WalletPreview adress={address} />
                ))}
              </FlexKit> */}
            </div>
          }

        </FlexKit>
      </div>
    </main>

  </div>
}; 